import React from "react";

const Modal = ({ close, setModal, children }) => (
  <div className="shared-modal" onClick={close}>
    <div
      className="shared-modal-modal-window"
      ref={setModal}
      style={{ borderRadius: "20px" }}
    >
      {children}
    </div>
  </div>
);

export default Modal;
